import React from 'react';

import { Text, View, StyleSheet } from 'react-native';

import { connect } from 'react-redux';

import {
  getEditingPatient,
  getEditingPatientCurrentImmunizations,
  getEditingPatientRequiredImmunizations,
  getEditingPatientDeploymentInfo,
} from '../patient/selector';

import {
  OPComponent,
  Container,
  NavBar,
  I18n,
  Utils,
  Navigation,
  SimpleHeader,
  CheckButtonList,
} from '../components';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

class SelectImmunes extends OPComponent {
  static options(passProps) {
    return {
      topBar: {
        leftButtons: [NavBar.buttons.done],
      },
    };
  }

  constructor(props) {
    super(props);

    const { requiredImmunizations, otherImmunizations, currentImmunizations } =
      this.prepImmunizations(props);

    const selectedImmunes = props.selectedImmunes;

    this.state = {
      requiredImmunizations: selectedImmunes?.requiredImmunizations?.length
        ? selectedImmunes.requiredImmunizations
        : requiredImmunizations,
      otherImmunizations: selectedImmunes?.otherImmunizations?.length
        ? selectedImmunes.otherImmunizations
        : otherImmunizations,
      currentImmunizations,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Airforce', 'Select Immunizations for Appointment');
    Navigation.registerForButtonEvents(this);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  prepImmunizations = (props) => {
    const currentImmunes = Object.keys(props.currentVaccines).sort();

    const requiredImmunes = props.requiredVaccines
      .filter((vaccine) => !currentImmunes.includes(vaccine))
      .sort();
    const otherImmunes = this.props.allVaccines
      .filter((vaccine) => !requiredImmunes.concat(currentImmunes).includes(vaccine))
      .sort();

    function mapNames(vName) {
      return {
        label: vName,
        id: vName,
        checked: false,
      };
    }

    const requiredImmunizations = requiredImmunes.map(mapNames);
    const otherImmunizations = otherImmunes.map(mapNames);
    const currentImmunizations = currentImmunes.map(mapNames).map((i) => {
      return {
        ...i,
        checked: true,
        editable: false,
      };
    });

    return { requiredImmunizations, otherImmunizations, currentImmunizations };
  };

  renderCurrentImmunizations = () => {
    const props = this.props;
    if (!this.state.currentImmunizations) return null;
    if (!props.editingPatient) return null;

    return (
      <View style={styles.container}>
        <SimpleHeader label={I18n.t('airforce.currentImmunizations')} />
        {!this.state.currentImmunizations?.length && (
          <View style={styles.nextButtonContainer}>
            <Text style={styles.notDeployedText}>{I18n.t('none')}</Text>
          </View>
        )}
        <CheckButtonList
          items={this.state.currentImmunizations}
          multi={true}
          onValuesChanged={this.handleCurrentImmunizationPress}
        />
      </View>
    );
  };

  handleImmunizationSelection = (requiredImmunizations) => {
    this.setState({ requiredImmunizations });

    this.props.onSelectionChange({
      requiredImmunizations,
      otherImmunizations: this.state.otherImmunizations,
    });
  };

  handleOtherImmunizationSelection = (otherImmunizations) => {
    this.setState({ otherImmunizations });

    this.props.onSelectionChange({
      requiredImmunizations: this.state.requiredImmunizations,
      otherImmunizations,
    });
  };

  renderRequiredImmunizations = () => {
    const props = this.props;
    if (!this.state.requiredImmunizations) return null;
    if (!props.deploymentInfo) return null;

    return (
      <View style={styles.container}>
        <SimpleHeader label={I18n.t('airforce.requiredImmunizations')} />
        <CheckButtonList
          items={this.state.requiredImmunizations}
          multi={true}
          onValuesChanged={this.handleImmunizationSelection}
        />
      </View>
    );
  };

  renderOtherImmunizations() {
    const props = this.props;
    if (!this.state.otherImmunizations?.length) return null;

    const singlePatient = !!props.editingPatient;

    return (
      <View style={styles.container}>
        {!!singlePatient && <SimpleHeader label={I18n.t('airforce.otherImmunizations')} />}
        <CheckButtonList
          items={this.state.otherImmunizations}
          multi={true}
          onValuesChanged={this.handleOtherImmunizationSelection}
        />
      </View>
    );
  }

  render() {
    return (
      <Container scrollView={true}>
        {this.renderCurrentImmunizations()}
        {this.renderRequiredImmunizations()}
        {this.renderOtherImmunizations()}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
  nextButtonContainer: {
    paddingBottom: 25,
    paddingHorizontal: 35,
    paddingTop: 20,
    borderTopWidth: 1,
    borderColor: '#e4e4e4',
  },
  notDeployedText: {
    ...FONT.medium,
    fontSize: 16,
    color: COLOR.text,
    marginBottom: 7,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    editingPatient: getEditingPatient(state),
    currentVaccines: getEditingPatientCurrentImmunizations(state),
    requiredVaccines: getEditingPatientRequiredImmunizations(state),
    deploymentInfo: getEditingPatientDeploymentInfo(state),
    allVaccines: state.entities.metaData.allVaccines,
  };
}

export default connect(mapStateToProps, null)(SelectImmunes);
